import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {BrowserRouter} from "react-router-dom";
import RtlProvider from "./hoc/RtlProvider";
import {Provider} from "react-redux";
import {store, persist} from "./redux/store/index.store";
import {PersistGate} from "redux-persist/integration/react";
import Loading from "./components/Site/Loading/Loading";
import {QueryClient, QueryClientProvider} from 'react-query';
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();


root.render(
    <QueryClientProvider client={queryClient}>

    <Provider store={store}>
        <PersistGate loading={<Loading/>} persistor={persist}>
            <RtlProvider >
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </RtlProvider>
        </PersistGate>
    </Provider>

        <ToastContainer
            bodyStyle={{direction: 'rtl', fontSize: 'smaller', color: '#525252'}}
            // style={{direction:theme.direction, fontSize:'smaller', color:'#00f'}}
            // toastStyle={{direction:theme.direction, fontSize:'smaller', color:'#00f'}}
        />

    </QueryClientProvider>
);
